export default function genererEntiteCommerciale() {
  return {
    enseignesMarques: [],
    nbHabitantsAireUrbaine: null,
    audienceAn: null,
    nbContactsAn: null,
    audienceHebdo: null,
    nbContactsHebdo: null,
    localite: null,
    revenuNetMenageAn: null,
    surface: null,
    indiceCsp: null,
  };
}
